var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.00001C1.79565 5.00001 2.55872 5.31608 3.12133 5.87869C3.68394 6.4413 4.00001 7.20437 4.00001 8.00002C4.00001 8.79567 3.68394 9.55874 3.12133 10.1213C2.55872 10.684 1.79565 11 1 11V13C1 13.5305 1.21071 14.0392 1.58579 14.4143C1.96086 14.7893 2.46957 15 3.00001 15H19.0001C19.5305 15 20.0392 14.7893 20.4143 14.4143C20.7893 14.0392 21.0001 13.5305 21.0001 13V11C20.2044 11 19.4413 10.684 18.8787 10.1213C18.3161 9.55874 18.0001 8.79567 18.0001 8.00002C18.0001 7.20437 18.3161 6.4413 18.8787 5.87869C19.4413 5.31608 20.2044 5.00001 21.0001 5.00001V3.00001C21.0001 2.46957 20.7893 1.96086 20.4143 1.58579C20.0392 1.21071 19.5305 1 19.0001 1H3.00001C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3.00001V5.00001Z",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.00001L10 10L14 6",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.00785b2a3830126280de0e395c620a06.svg";
export { ForwardRef as ReactComponent };